import { Observable, Subject } from "rxjs";
import { ToastMessageType } from "./ToastMessageType";
import { ToastButtons } from "./ToastButtons";
import { ToastResponse } from "./ToastResponses";

export class MultiLineContent {
    description: string;
    symbol: string;
}

export interface SimpleMessage {
    title: string;
    content: string;
    multiLineContent: MultiLineContent[];
}

export class Message implements SimpleMessage {
    title: string;
    content: string;
    multiLineContent: MultiLineContent[];
    messageType: ToastMessageType;
    dismissed: boolean;
    subject: Subject<any>;
    buttons: ToastButtons;
    showLoader: boolean = false;
    readonly uniqueId: string;
    readonly async: Observable<any>;
    private timeoutReference: any;

    constructor(title: string, content, messageType?: ToastMessageType, buttons?: ToastButtons, async: Observable<any> = null) {
        this.title = title;
        this.content = content;
        this.messageType = messageType || ToastMessageType.info;
        this.uniqueId = Message.makeid();
        this.subject = new Subject<ToastResponse>();
        this.buttons = buttons || ToastButtons.None;
        this.async = async;
    }

    complete(result: ToastResponse) {
        this.sendResponse(result);
        this.subject.complete();
    }

    sendResponse(result: ToastResponse) {
        this.subject.next(result);
    }
    
    close() {
        this.subject.complete();
    }

    getObservable(): Observable<ToastResponse> {
        return this.subject.asObservable();
    }

    setTimeoutReference(timeoutReference: any) {
        this.timeoutReference = timeoutReference;
    }

    getTimeoutReference() {
        return this.timeoutReference;
    }

    private static makeid(length: number = 35) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }
}